/**
 * Smoothly scrolls to a page section by ID, accounting for the fixed
 * header and optional flashing banner height.
 *
 * @param {string} sectionId - The `id` attribute of the target element.
 */
export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (!element) return;

  const headerHeight = document.querySelector('header')?.offsetHeight || 80;
  const bannerHeight = document.querySelector('.flashing-banner')?.offsetHeight || 0;

  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerHeight - bannerHeight;

  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
};
